import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { LocalStorageManager } from "@shared/utils/local-storage-manager";
import { AccountsService } from "../services/accounts.service";
import { from, switchMap } from "rxjs";
import { BYPASS_AUTH, SKIP_ACCOUNT_ID, SKIP_HEADERS, USE_CC_TOKEN } from "./http-context-tokens";
// import { AuthService } from "../services/auth.service";



export const jwtInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const accountService = inject(AccountsService);
  const localStorageManager: LocalStorageManager = inject(LocalStorageManager);

  const interceptorFn = () => {
    const accessToken = localStorage.getItem('accessToken') || '';
    const ccToken = localStorage.getItem('ccToken') || '';

    if (request.url.match(/.*\.json/) || request.context.get(SKIP_HEADERS) || request.context.get(BYPASS_AUTH)) {
      const headers: Record<string, string> = {
        "Accept-Language": localStorageManager.getData("selectedLanguage") || "en",
      };

      request = request.clone({
        setHeaders: headers,
      });

      return next(request)
    }

    const headers: Record<string, string> = {
      Authorization: ccTokenRequest(request) ? `Bearer ${ccToken}` : `Bearer ${accessToken}`,
      Accept: "application/json",
      "Accept-Language": localStorageManager.getData('selectedLanguage') || 'en',
    }

    if (!request.context.get(SKIP_ACCOUNT_ID)) {
      headers["Account-Id"] = accountService.accountId + '' || '';
    }
    request = request.clone({ setHeaders: headers });
    return next(request);
  }

  if (request.context.get(BYPASS_AUTH) || request.context.get(SKIP_HEADERS)) {
    return interceptorFn();
  }


  if (request.context.get(SKIP_ACCOUNT_ID)) {
    return interceptorFn();
  }

  const hasToken = !!localStorage.getItem('accessToken');
  if (!hasToken) {
    return interceptorFn();
  }

  return from(accountService.ensureAccountId()).pipe(
    switchMap(() => interceptorFn()),
  );
};

export const ccTokenRequest = (request: HttpRequest<any>) => {
  return request.context.get(USE_CC_TOKEN) ? true : false;
}
